import React from "react"
import { ISearchValue, SearchTypeEnum } from "../../../../components2/YhPageHeader/Types";
import { YhPageHeader } from "../../../../components2/YhPageHeader";
import { useDataJournalModel } from "../dataJournalModel"
import useMdmModel from "../../../../model/mdmModel"

export function SearchForm() {
    const {
        searchParam,
        upDataSearchParam,
        resetSearchParam,
        loadData
    } = useDataJournalModel();
    const {mdmCatalog,mdmBranch} = useMdmModel();
    const searchFields = [
        {
            type: SearchTypeEnum.Select,
            span: 4,
            placeholder: "分支编码",
            fieldName: "branch",
            size: "small",
            disabled: false,
            options: mdmBranch
        },
        {
            type: SearchTypeEnum.Select,
            span: 4,
            placeholder: "数据目录编码",
            fieldName: "catalog",
            size: "small",
            disabled: false,
            options: mdmCatalog
        },
        {
            type: SearchTypeEnum.Select,
            span: 4,
            placeholder: "操作类型",
            fieldName: "execType",
            size: "small",
            disabled: false,
            options:[{key:"S",label:"查询",value:"S"},{key:"I",label:"新增",value:"I"},{key:"U",label:"修改",value:"U"},{key:"D",label:"删除",value:"D"}]
        },
        {
            type: SearchTypeEnum.Select,
            span: 4,
            placeholder: "执行状态",
            fieldName: "execStatus",
            size: "small",
            disabled: false,
            options:[{key:"0",label:"待审核",value:"0"},{key:"1",label:"执行中",value:"1"},{key:"2",label:"执行成功",value:"2"},{key:"9",label:"执行异常",value:"9"}]
        },
        // {
        //     type: SearchTypeEnum.Select,
        //     span: 4,
        //     placeholder: "来源",
        //     fieldName: "sourceApp",
        //     size: "small",
        //     disabled: false,
        //     options:[{key:"fms",label:"财务系统",value:"fms"},{key:"vrm",label:"云修系统",value:"vrm"}]
        // },
    
    ]
    return (
        <YhPageHeader
            title="请求日志列表"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={upDataSearchParam}
            handleSearch={loadData}
            handleReset={resetSearchParam}
        />
    )
}